<template>
	<loading-spinner v-if='loading' />

	<component :is='filterComponentName' v-else :filter='filter' />
</template>

<script>
import BaseFilterMixin from './BaseFilterMixin'
import SelectFilter from '@/components/filter/SelectFilter'
import LoadingSpinner from '@/components/LoadingSpinner'

export default {
	name: 'DependencyFilter',
	components: {LoadingSpinner, SelectFilter},
	mixins: [BaseFilterMixin],

	data: () => {
		return {
			loading: true,
		}
	},
  computed: {
    filterComponentName() {
      if (!this.filter.display_as) return ''
      return this.filter.display_as.charAt(0).toUpperCase() + this.filter.display_as.slice(1) + 'Filter'
    },
  },
	async mounted() {
	  await this.openFilter()
    this.$bus.$on('v-menu-open:'+this.filter.name, async () => {
      await this.openFilter()
    })
    this.$bus.$on('v-menu-close:'+this.filter.name, async () => {
      this.loading = true
    })
	},
  methods: {
	  async openFilter() {
      const parentFilter = this.$store.filters.find(f => f.name === this.filter.depends.on)
      if (!parentFilter) return console.warn('dependency filters depend on is not in the filters list')

      if (parentFilter.selectedValues && parentFilter.selectedValues.length) {
        const parent_ids = []

        parentFilter.selectedValues.forEach(value => {
          parent_ids.push(value.id || value.value || value)
        })

        let filter_values = [...this.filter.values]

        const depends = this.filter.depends

        for (let id of parent_ids) {
          let url = depends.valuesUrl.replace(`{${depends.on}}`, id)
          let value = await this.$http.get(url)
          if (value) {
            if (Array.isArray(value)) {
              filter_values = [...filter_values, ...value]
            } else {
              filter_values.push(value)
            }
          }
        }

        this.filter.values = filter_values.filter((item) => {
          return item.visible === 1 || item.default === true || item.visible === null
        }).map(item => {
          return {
            label: item.label || item.title,
            value: item.id,
            id: item.id,
            default: item.default || false
          }
        })
        this.loading = false
      }
    }
  }
}
</script>

<style>
button.v-btn.select_btn, button.v-btn.select_btn .v-btn__content {
	font-size: 12.5px;
}

button.v-btn.select_btn .v-btn__content {
	width: 100%;
	max-width: 100%;
}

button.v-btn.select_btn {
	padding: 0 10px !important;
	max-width: 250px !important;
}

button.v-btn.select_btn.v-size--small {
	height: 32px !important;
}
</style>